<template>
    <v-dialog max-width="615px"
              scrollable
              v-model="dialogVisible"
              persistent>
        <v-form ref="form"
                v-model="valid"
                lazy-validation>
            <v-card class="pa-8 rounded-xl" flat>
                <v-card-title>
                    <v-col>
                        <v-row justify="center">
                            <v-icon class="ma-4 font-weigth-thin" size="76px" color="primary">mdi-file-lock-outline</v-icon>
                        </v-row>
                        <v-row justify="center">
                            <span class="text-large">{{ $t('user-management.reportAccessTitle') }}</span>
                        </v-row>
                    </v-col>
                </v-card-title>
                <v-card-subtitle>
                    <v-row class="my-1" justify="center">
                        <span class="text-normal better-break" v-html="$t('user-management.reportAccessSubtitle', { fullName: fullName})"></span>
                    </v-row>
                </v-card-subtitle>
                <v-alert v-if="this.errorMsg" class="mx-4 pa-3 d-inline-block" dense dark type="error">{{$t(this.errorMsg)}}</v-alert>
                <v-row v-if="loading" align="center" justify="center">
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                </v-row>
                <v-card-text v-else>
                    <v-expansion-panels v-model="currentReportIndex">
                        <v-expansion-panel v-for="(report,rptIdx) in reports"
                                           :key="report.ReportId"
                                           class="text-norma mb-1 rounded-lg">
                            <v-expansion-panel-header>
                                <template v-slot:default="{ open }">
                                    <span v-if="$i18n.locale == 'en'" :class="open ? 'primary--text' : ''">{{report.DisplayTextEn.toUpperCase()}}</span>
                                    <span v-else :class="open ? 'primary--text' : ''">{{report.DisplayTextFr.toUpperCase()}}</span>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card v-for="(group, gi) in report.UserConfiguredCriteria"
                                        :key="`group_${gi}`"
                                        flat outlined
                                        class="ma-1 pa-1 pb-2">
                                    <v-row>
                                        <v-col cols="10">
                                            <v-row v-for="(attribut, ai) in group"
                                                   :key="`row_${gi}_${ai}`"
                                                   class="ma-0">
                                                <v-text-field v-model="attribut.Value"
                                                              class="ma-1"
                                                              hide-details
                                                              :rules="allFiled(rptIdx, gi)"
                                                              required
                                                              maxlength="255"
                                                              :key="`field_${gi}_${ai}`"
                                                              :label="$i18n.locale === 'en' ? attribut.DisplayTextEn : attribut.DisplayTextFr">
                                                </v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="2" align-self="center">
                                            <v-btn v-if="!disableAttributesEdits"
                                                   class="ma-1"
                                                   color='primary'
                                                   dark
                                                   text
                                                   depressed
                                                   height="56px"
                                                   width="56px"
                                                   @click="removeAttribute(rptIdx,gi)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-row align="center" class="ma-0">
                                    <v-col cols="10">
                                        <v-select v-if="!disableAttributesEdits"
                                                  v-model="report.AddNewAttribute"
                                                  hide-details
                                                  readonly
                                                  append-icon=""
                                                  multiple
                                                  class="ma-1 select-max-width"
                                                  :items="attributeList(rptIdx)"
                                                  :label="$t('attribute')">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn class="ma-1"
                                               color='primary'
                                               dark
                                               text
                                               depressed
                                               height="56px"
                                               width="56px"
                                               @click="addReportAttribute(report)">
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                            </v-expansion-panel-content>
                        </v-expansion-panel>

                    </v-expansion-panels>
                </v-card-text>
                <v-card-actions>
                    <v-row justify="center" class="py-4">
                        <v-btn color="primary"
                               class="text-none text-normal ma-2"
                               min-width="33%"
                               x-large
                               depressed
                               v-bind:disabled="busy"
                               @click="save">
                            {{$t('user-management.confirm')}}
                            &nbsp;
                            <v-progress-circular v-if="busy" indeterminate
                                                 color="primary">
                            </v-progress-circular>
                        </v-btn>
                        <v-btn color="primary"
                               class="text-none text-normal ma-2"
                               min-width="33%"
                               x-large
                               depressed
                               @click="cancel">
                            {{$t('cancel')}}
                        </v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-form>
        <v-dialog v-model="successSnackbar" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="#74DF13"
                            class="my-5">mdi-check-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1"><span v-html="successMessage"></span></v-card-subtitle>
            </v-card>
        </v-dialog>
        <v-dialog v-model="errorSnackbar" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="red"
                            class="my-5">mdi-close-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ $t('user-management.reportAccessErrorText') }}</v-card-subtitle>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ (errorMessage != null? errorMessage: '') }}</v-card-subtitle>
                <v-card-actions>
                    <v-row justify="center">
                        <v-btn class="text-normal" depressed color="primary" width="33%" x-large @click="errorSnackbar = false">OK</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>

    export default {
        name: 'ReportAccess',
        props: {
            userId: {
                type: Number
            },
            dialog: {
                type: Boolean,
                required: true,
                default: false
            },
            disableAttributesEdits: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                errorMsg: "",
                dialogVisible: false,
                editedUser: {

                },
                valid: true,
                busy: false,
                successSnackbar: false,
                successMessage: undefined,
                errorSnackbar: false,
                errorMessage: undefined,
                currentReportIndex: 0,
                loading: true,
            }
        },
        computed: {
            reports() {
                return this.editedUser.Reports;
            },
            fullName() {
                return this.editedUser.FirstName + ' ' + this.editedUser.LastName;
            }
        },
        watch: {
            userId(val) {
                //this.editedUser = Object.assign({}, val);
                if (!isNaN(val) && (val > 0)) {
                    this.getUserReportAccess(val);
                }
                this.currentReportIndex = 0;
            },
            dialog(val) {
                this.dialogVisible = val
            },
            successSnackbar: function (newVal) {
                if (newVal == true) {
                    setTimeout(() => {
                        this.successSnackbar = false;
                        this.successMessage = undefined;
                    }, 2000);
                }
            },
        },
        created() {
            //this.editedUser = Object.assign({}, this.user);
            //this.getUserReportAccess(this.userId);
            this.dialogVisible = this.dialog;
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            addReportAttribute: function (report) {
                if (report?.AddNewAttribute == null) { return; }
                var group = [];
                var maxGroup = -1;
                for (let i = 0; i < report.UserConfiguredCriteria.length; i++) {
                    for (let j = 0; j < report.UserConfiguredCriteria[i].length; j++) {
                        if (report.UserConfiguredCriteria[i][j].Group > maxGroup) {
                            maxGroup = report.UserConfiguredCriteria[i][j].Group;
                        }
                    }
                }
                for (let i = 0; i < report.AddNewAttribute.length; i++) {
                    group.push({
                        DisplayTextEn: report.AddNewAttribute[i].DisplayNameEN,
                        DisplayTextFr: report.AddNewAttribute[i].DisplayNameFR,
                        ReportAttributeId: report.AddNewAttribute[i].Id,
                        Value: "",
                        Group: maxGroup + 1
                    });
                }
                report.UserConfiguredCriteria.push(group);
            },
            getUserReportAccess(userId) {
                let self = this;
                self.loading = true;

                return this.$axios.get(`api/usermanagement/users/${userId}`)
                    .then((response) => {
                        if (response.data.success == false && response.data.error == 'session-expired') {
                            self.$router.push({ name: 'login' });
                        } 
                        self.editedUser = response.data.Users[0];
                        self.loading = false;
                    }).catch(() => {
                        self.loading = false;
                    });
            },
            removeAttribute(rptIdx, attributeIdx) {
                this.editedUser.Reports[rptIdx].UserConfiguredCriteria.splice(attributeIdx, 1);
            },
            RemoveEmptyAttributes(reportsConfigs) {
                for (var rIdx = 0; rIdx < reportsConfigs.length; rIdx++) {
                    var report = reportsConfigs[rIdx];

                    for (var rUIdx = report.UserConfiguredCriteria.length - 1; rUIdx  >= 0 ; rUIdx--) {
                       if (report.UserConfiguredCriteria[rUIdx].every(x => x.Value == null || x.Value.length == 0)) {
                            report.UserConfiguredCriteria.splice(rUIdx, 1);
                        }

                    }
                }
            },
            save: function () {
                this.$refs.form.validate();
                if (this.valid) {
                    this.$refs.form.resetValidation();
                    var self = this,
                        url = "api/usermanagement/savereportaccess",
                        reportsConfigs = JSON.parse(JSON.stringify(this.reports)),
                        payload = {
                            userId: self.editedUser.Id,
                            submitedReports: reportsConfigs
                        },
                        fullName = self.editedUser.FirstName + ' ' + self.editedUser.LastName;

                    this.RemoveEmptyAttributes(reportsConfigs);
                    for (var rIdx = 0; rIdx < reportsConfigs.length; rIdx++) {
                        var report = reportsConfigs[rIdx];
                        delete report['RequiredAttributes'];
                        report.Access = false;

                        for (var rUIdx = 0; rUIdx < report.UserConfiguredCriteria.length; rUIdx++) {
                            for (let j = 0; j < report.UserConfiguredCriteria[rUIdx].length; j++) {
                                if ((report.UserConfiguredCriteria[rUIdx][j].Value != null)
                                    && (report.UserConfiguredCriteria[rUIdx][j].Value.length)) {
                                    report.Access = true;
                                    break;
                                }
                            }
                        }
                    }

                    this.busy = true;

                    this.$axios.post(url, payload)
                        .then((response) => {
                            self.busy = false;
                            if (response.data.success == false && response.data.error == 'session-expired') {
                                self.$router.push({ name: 'login' });
                            } 
                            self.successMessage = self.$t('user-management.reportAccessSuccessText', { fullName: fullName });
                            self.successSnackbar = true;
                            self.$emit('save', self.editedUser);

                        })
                        .catch(function (response) {
                            self.busy = false;
                            self.errorMessage = response.data.msg;
                            self.errorSnackbar = true;
                            self.$emit('save', self.editedUser);
                        })
                }
            },
            attributeList(rptIdx) {
                var attrList = [];
                for (var i = 0; i < this.editedUser.Reports[rptIdx].RequiredAttributes.length; i++) {
                    attrList.push({
                        value: this.editedUser.Reports[rptIdx].RequiredAttributes[i],
                        text: this.$i18n.locale == 'en' ? this.editedUser.Reports[rptIdx].RequiredAttributes[i].DisplayNameEN : this.editedUser.Reports[rptIdx].RequiredAttributes[i].DisplayNameFR
                    });
                }

                if (this.editedUser.Reports[rptIdx].RequiredAttributes.length) {
                    this.editedUser.Reports[rptIdx].AddNewAttribute = this.editedUser.Reports[rptIdx].RequiredAttributes;
                }
                return attrList;
            },
            allFiled(reportIndex, groupIndex) {
                let report = this.editedUser.Reports[reportIndex];
                if (report.UserConfiguredCriteria[groupIndex].some(x => x.Value != null && x.Value.length > 0)) {
                    if (report.UserConfiguredCriteria[groupIndex].some(x => x.Value == null || x.Value.length == 0)) {
                        return [''];
                    }
                }
                return [true];
            }
        }
    }
</script>
<style scoped>
    .better-break {
        word-break: normal;
        word-wrap: normal;
        text-align: center;
    }
    .v-expansion-panel {
        border: 2px solid !important;
        border-color: var(--primary) !important;
    }
    .select-max-width {
        max-width: 83% !important;
    }
</style>